import type { IconProps } from "../types";

export const Pencil = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M21.92 5.66 18.34 2.08 3.84 16.17 2 22 7.83 20.17 Z" />
    <path d="m15 5 4 4" />
  </svg>
);
